import React from 'react';
import Modal from "../../components/modal/modal";
import styles from './init-tipsModal.css'

const TaskDescModal = ({ onClose, task, onConfirm, type, onRestudy, onAnswer,homework }) => {

    return (
        <Modal
            title={task.name}
            onClose={type !== 'new' ? onClose : null}
        >
            <div>
                <p>{task.desc}</p>
                {
                    task.attach !== '' &&
                    <p>教学文件下载:<a target='_blank'>{task.attach}</a></p>
                }
            </div>
            {
                type === 'new' ? (
                    <div className={styles.btn}>
                        <span onClick={onConfirm}>开始学习</span>
                    </div>
                ) : (
                    <div className={styles.btn}>
                        <span onClick={onRestudy}>重新学习</span>
                        <span onClick={onClose}>继续学习</span>
                        {!homework && <span onClick={onAnswer}>标准答案</span>}
                    </div>
                )
            }
        </Modal>

    );
}

export default TaskDescModal;
